import ozToggle from '@/components/oz-toggle'

import { areaFieldsMapper } from '@/utils/transformers/filters/areas'

export default {
  name: 'oz-toggle-total-area',

  props: {
    filters: { type: Object, required: true },
    totalArea: { type: Boolean },
  },

  data () {
    return {
      initialValue: false,
    }
  },

  created () {
    this.initialValue = this.totalArea
  },

  methods: {
    updateTotalArea (filterForTotalArea) {
      const min = this.filters.usableAreasMin || this.filters.totalAreasMin
      const max = this.filters.usableAreasMax || this.filters.totalAreasMax

      const areas = areaFieldsMapper(filterForTotalArea, { min, max })
      this.$emit('filters:update', { ...areas }, filterForTotalArea)
    },
  },

  components: {
    ozToggle,
  },
}
